import React from 'react'

import { Label } from 'components/typo'
import classnames from 'classnames/bind'
import { ReactComponent as CloseIcon } from './close.svg'

import css from './styles.module.scss'

classnames.bind(css)

const OptionTag = ({ text, facetKey, onClick }) => (
  <li className={css.OptionTag}>
    <Label className={css.label} theme="white">
      {text}
    </Label>
    <span className={css.closeIcon}>
      <CloseIcon onClick={() => onClick(facetKey, text)} />
    </span>
  </li>
)

export default OptionTag
